import { z } from 'zod'

export const editPedidoSchema = z.object({
  id_pedido: z.number().int().positive('ID do pedido é obrigatório'),
  nome_produto: z.string().optional(),
  cor_produto: z.string().optional(),
  gravacao: z.string().optional(),
  quantidade: z
    .string()
    .optional()
    .transform((val) => (val ? Number(val.replace(/\./g, '').replace(',', '.')) : undefined)),
  valor_unitario: z
    .string()
    .optional()
    .transform((val) =>
      val
        ? Number(
            val
              .replace(/R\$\s?/, '')
              .replace(/\./g, '')
              .replace(',', '.')
          )
        : undefined
    ),
  sub_total: z
    .string()
    .optional()
    .transform((val) =>
      val
        ? Number(
            val
              .replace(/R\$\s?/, '')
              .replace(/\./g, '')
              .replace(',', '.')
          )
        : undefined
    ),
  link_logo: z.string().optional(),
  link_pdf: z.string().optional(),
  observacao: z.string().optional(),
  prazo_producao: z
    .string()
    .optional()
    .transform((val) => (val ? Number(val.replace(/\D/g, '')) : undefined)),
  data_entrada: z.string().optional(),
  codigo_produto: z.string().optional(),
})

export function formatCurrency(value) {
  if (!value && value !== 0) return ''
  return `R$ ${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatQuantidade(value) {
  if (!value && value !== 0) return ''
  return Number(value).toLocaleString('pt-BR')
}

export function formatCurrencyToNumber(value) {
  if (!value) return 0
  return Number(
    value
      .replace(/R\$\s?/, '')
      .replace(/\./g, '')
      .replace(',', '.')
  )
}

export function formatQuantidadeToNumber(value) {
  if (!value) return 0
  return Number(value.replace(/\./g, '').replace(',', '.'))
}

export function calculateSubtotal(quantidade, valorUnitario) {
  const qtd = formatQuantidadeToNumber(quantidade)
  const valor = formatCurrencyToNumber(valorUnitario)
  return qtd * valor
}
